import { observable, action, runInAction, computed, makeObservable } from "mobx";
import { API } from "General/API";
import { projectsDataStore } from "Stores/ProjectsStore";
import { CoreStore } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";

class OverviewSitemapStore extends CoreStore {
  documents: DocumentsTreeviewUI;

  constructor() {
    super();

    makeObservable(this, {
      documents: observable.shallow,
      clear: action.bound,
      fetch: action.bound,
      fetchFolderById: action.bound,
      fetchPath: action.bound,
      data: computed,
    });
  }

  clear() {
    this.documents = {} as DocumentsTreeviewUI;
  }

  url(folderId?: number) {
    if (folderId) {
      return API_URL.FOLDERS.getSubfolders(projectsDataStore.projectId, folderId);
    } else {
      return API_URL.FOLDERS.getTreeRoot(projectsDataStore.projectId);
    }
  }

  async fetch() {
    try {
      const response: API_TreeElement = await API.getData(this.url());
      runInAction(() => {
        if (response.subfolders) {
          this.documents = { ...response, subfolders: this.normalizeResponse(response.subfolders) };
        }
      });
    } catch (err) {
      runInAction(() => {
        this.reset();
      });
      throw err;
    }
  }

  async fetchFolderById(folderId: number) {
    try {
      const copy = this.documents.subfolders.concat();
      const foundItem = this.findInTree(copy, folderId);
      if (foundItem) {
        // tslint:disable-next-line:max-line-length
        const response: API_TreeElement = await API.getData(this.url(folderId));
        runInAction(() => {
          const normalized = this.normalizeResponse(response.subfolders) as DocumentsTreeviewUI[];
          foundItem.subfolders = normalized;
          this.documents.subfolders = copy;
        });
      }
    } catch (err) {
      runInAction(() => {
        this.reset();
      });
      throw err;
    }
  }

  async fetchPath(id: number) {
    try {
      const response = await API.getData(this.url(id));
      runInAction(() => {
        this.documents.subfolders = response.subfolders;
      });
    } catch (err) {
      throw err;
    }
  }

  get data(): DocumentsTreeviewUI[] {
    return this.documents.subfolders ? this.documents.subfolders.slice() : [];
  }

  private normalizeResponse(response: API_TreeElement[]): DocumentsTreeviewUI[] {
    return (
      response &&
      response.map((item) => {
        // if item is Folder - adjust with UI props
        return {
          ...item,
          link: `/project/${projectsDataStore.projectId}/documents/docs/${item.id}`,
        };
      })
    );
  }

  private findInTree = (array, id: number) => {
    let item: DocumentsTreeviewUI;
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === id) {
        item = array[i];
        break;
      } else if (array[i].subfolders) {
        const found = this.findInTree(array[i].subfolders, id);
        if (found) {
          item = found;
        }
      }
    }
    return item;
  };
}

const sitemapStore = new OverviewSitemapStore();

export { sitemapStore, OverviewSitemapStore };
